import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

// On a native (Capacitor) build the OS draws the real status bar — we never fake it.
// We just tell it to overlay the full-bleed web view and use dark text to suit our
// light "paper" surface. No-ops on web, where the browser owns the chrome.
export function useNativeChrome(): void {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    let cancelled = false;
    (async () => {
      try {
        const { StatusBar, Style } = await import('@capacitor/status-bar');
        if (cancelled) return;
        await StatusBar.setOverlaysWebView({ overlay: true });
        await StatusBar.setStyle({ style: Style.Light }); // dark text for the light background
      } catch {
        // Status bar plugin unavailable (e.g. unsupported platform) — ignore.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
}
